/* generated by pull.js */
const manifest = {
  "enabledByDefault": true,
  "editorOnly": true,
  "name": "Move costume to top or bottom",
  "description": "Adds a right click context menu item to move a costume or a sound to the top or the bottom of the list. Previously part of the developer tools.",
  "tags": [],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "dynamicEnable": true,
  "dynamicDisable": true
};
export default manifest;
